import CaptureOther from './CaptureOther';

export default CaptureOther;
